import { VariantEnum } from '@/config/constants';
import { FloatingNotification } from '@/design-system';
import { LiveFeedback } from '@/components/LiveFeedback/LiveFeedback';
import { css } from '@emotion/css';

export const AidaOffNotification = () => {
  const message =
    'AiDA enhanced accessible text and translations are not enabled at your district.';
  return (
    <div className={cn.container}>
      <FloatingNotification variant={VariantEnum.info}>{message}</FloatingNotification>
      <LiveFeedback ariaLive="polite" message={message} />
    </div>
  );
};

const cn = {
  container: css`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    width: 100%;
    padding: 0 16px;
  `,
};
